export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[600px] w-full items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=energetic%20crowd%20of%20happy%20young%20people%20watching%20phones%20with%20surprise%20and%20excitement%2C%20stylized%20flat%20illustration%20dominated%20by%20watermelon%20red%20and%20cream%20with%20fresh%20green%20accents%2C%20large%20cinematic%20wide%20composition%2C%20playful%20social%20media%20drama%20theme%2C%20no%20text&width=1600&height=900&seq=hero-main-01&orientation=landscape"
        alt="一群围观群众兴奋地围观手机屏幕上的热门事件"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-900/70 via-primary-900/50 to-primary-950/80"></div>

      <div className="relative mx-auto w-full max-w-6xl px-4 py-24 md:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
            <span className="flex h-2 w-2 items-center justify-center">
              <span className="h-2 w-2 animate-pulse rounded-full bg-accent-400"></span>
            </span>
            今日已有 128 个现场正在发酵
          </span>

          <h1 className="mt-6 font-display text-4xl leading-tight text-white md:text-6xl">
            前排围观,在线吃瓜
            <span className="mt-2 block text-accent-300">轻松跟上每一波节奏</span>
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
            爆炸瓜是吃瓜群众的聚集地,为你送上实时热榜与现场速递。
            明星娱乐、社会热点、科技圈、影视综艺,想吃的瓜这里都有,先吃为敬!
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#hot"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-8 py-3 text-base font-semibold text-white whitespace-nowrap transition hover:bg-accent-500 sm:w-auto"
            >
              去看实时热榜
              <i className="ri-flashlight-fill" aria-hidden="true"></i>
            </a>
            <a
              href="#feed"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 px-8 py-3 text-base font-semibold text-white whitespace-nowrap backdrop-blur-sm transition hover:bg-white/20 sm:w-auto"
            >
              现场速递
              <i className="ri-play-circle-fill" aria-hidden="true"></i>
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-3 md:gap-6">
            {[
              { num: "1280+", label: "热门现场" },
              { num: "520万", label: "围观人次" },
              { num: "3600+", label: "每日瓜点" },
            ].map((s) => (
              <div key={s.label} className="rounded-2xl bg-white/10 px-3 py-4 backdrop-blur-sm md:px-4">
                <p className="font-display text-2xl text-accent-300 md:text-3xl">{s.num}</p>
                <p className="mt-1 text-xs text-white/75 md:text-sm">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}